
import { apiSlice } from '../../app/api/apiSlice'
// Automatically created using reduxslicer by Simo Virokannas, 2023

export const skuimageApi = apiSlice.injectEndpoints ({ 
  endpoints: (builder) => ({
    listSKUImages: builder.query ({
      query: (params) => `v2/skuimage/${params ? "?" + new URLSearchParams(Object.entries(params)).toString() : ""}`,
      keepUnusedDataFor: 1,
      providesTags: ["SKUImage"]
    }),
    getSKUImage: builder.query ({
      query: (skuimage_id) => `v2/skuimage/${skuimage_id}/`,
      keepUnusedDataFor: 1,
      providesTags: ["SKUImage"]
    }),

    updateSKUImage: builder.mutation ({
      query: ({skuimage_id, data}) => ({
        url: `v2/skuimage/${skuimage_id}/`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: ["SKUImage"]
    }),
    deleteSKUImage: builder.mutation ({
      query: (skuimage_id) => ({
        url: `v2/skuimage/${skuimage_id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: ["SKUImage"]
    }),
    createSKUImage: builder.mutation ({
      query: (data) => ({
        url: `v2/skuimage/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ["SKUImage"]
    }),
  })
})


export const {
  useListSKUImagesQuery,
  useLazyListSKUImagesQuery,
  useGetSKUImageQuery,
  useLazyGetSKUImageQuery,

  useUpdateSKUImageMutation,
  useDeleteSKUImageMutation,
  useCreateSKUImageMutation
} = skuimageApi
